import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DataEntity, Property } from "@Interfaces/index";
import { LoadingService } from "@services/loading.service";

@Component({
    selector: "app-depreciation-history",
    templateUrl: "./depreciation-history.component.html",
    styleUrls: ["./depreciation-history.component.css"],
})
export class DepreciationHistoryComponent implements OnInit {
    id: any;
    asset: any;
    isLoading = false;

    constructor(
        private aRoute: ActivatedRoute,
        public loadingService: LoadingService
    ) {}
    field: Property;
    dataEntity: DataEntity;
    group: string;
    item: any;

    setConfig(
        field: Property,
        dataEntity: DataEntity,
        group: string,
        item: any
    ) {
        this.field = field;
        this.dataEntity = dataEntity;
        this.group = group;
        this.item = item;
    }
    async ngOnInit() {
        this.id = this.aRoute.snapshot.paramMap.get("id");
    }
}
